/**
 * Per-route browser tab title (WCAG 2.4.2 Page Titled). `index.html` ships a neutral "TownDesk"
 * fallback (pre-mount / unknown routes); every mounted page calls this hook with its own title so
 * the tab always reflects "where am I" instead of being stuck on one static string.
 *
 * Deliberately tiny — no react-helmet: a page's title is a single string known at render time, so a
 * plain `useEffect` writing `document.title` is all that's needed. Callers build the string in the
 * shared "<Page> — <townName>" format themselves (see StaffShell / resident pages).
 */
import { useEffect } from "react";

export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title;
  }, [title]);
}

/** The shared "<Page> — <townName>" format, falling back to the neutral "TownDesk" brand when
 *  there's no page label (unknown route) or no town name (config not loaded yet). */
export function pageTitle(page: string | undefined, townName: string | undefined): string {
  const town = townName?.trim() || "TownDesk";
  return page?.trim() ? `${page} — ${town}` : "TownDesk";
}
